import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import goods from './modules/goods'
import staff from './modules/staff'
import express from './modules/express'
import system from './modules/system'
import image from './modules/image'
import information from './modules/information'
import order from './modules/order'
import coupon from './modules/coupon'
import activity from './modules/activity'
import home from './modules/home'
import role from './modules/role'
import print from './modules/print'
import statistics from './modules/statistics'
import appointment from './modules/appointment'
import business from './modules/business'
import supplier from './modules/supplier'
import evaluate from './modules/evaluate'
import inventory from './modules/inventory'
import application from './modules/application'
import yunxun from './modules/yunxun'
import baokexia from './modules/baokexia'
import jixiangtian from './modules/jixiangtian'
import treasure from './modules/treasure'
import news from './modules/news'
import wechart from './modules/wechart'
import saveLocal from './plugin/saveLocal'
import common from './modules/common'
import decoration from './modules/decoration'
import college from './modules/college'
import basic from './modules/basic'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    goods,
    staff,
    express,
    user,
    system,
    image,
    information,
    order,
    coupon,
    activity,
    home,
    role,
    print,
    statistics,
    appointment,
    business,
    supplier,
    evaluate,
    inventory,
    application,
    yunxun,
    baokexia,
    jixiangtian,
    treasure,
    news,
    college,
    wechart,
    common,
    decoration,
    basic
  },
  plugins: [saveLocal],
  state,
  getters,
  mutations,
  actions
})

export default store
